module.exports = __webpack_public_path__ + "media/images/profile_stallion-f54540277aaf8bb51902af2c4851f067.jpg";